module.exports = __webpack_public_path__ + "img/flightdeck-logo-inverse.6018fcf0.png";